/**
 * Common UI translations
 * Shared across all components
 */

import { LANGUAGES } from '../config';

export const commonTranslations = {
  [LANGUAGES.EN]: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    update: 'Update',
    create: 'Create',
    upload: 'Upload',
    download: 'Download',
    view: 'View',
    restore: 'Restore',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    loading: 'Loading...',
    saving: 'Saving...',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    confirm: 'Confirm',
    noDataFound: 'No data found',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    status: 'Status',
    actions: 'Actions',
    details: 'Details',
    date: 'Date',
    author: 'Author',
    version: 'Version',
    currentVersion: 'Current Version',
    versionHistory: 'Version History',
    analyze: 'Analyze',
    reviewing: 'Reviewing',
    published: 'Published',
    draft: 'Draft',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    profile: 'Profile',
    dashboard: 'Dashboard',
    settings: 'Settings',
    language: 'Language',
    english: 'English',
    french: 'French',
    user: 'User',
    manager: 'Manager',
    admin: 'Administrator',
    unknown: 'Unknown',
    none: 'None',
    poweredBy: 'Powered by Autobot',
    permissions: 'Role Permissions in Competency Analyzer',
    confirmBackTitle: 'Confirm Going Back',
    confirmBackMessage: 'Are you sure you want to go back? Any unsaved changes will be lost.',
    confirmBack: 'Yes, Go Back',
    noChanges: 'No changes detected',
    saveSuccess: 'Changes saved successfully',
    notSpecified: 'Not specified',
    dismiss: 'Dismiss',
    refresh: 'Refresh',
    all: 'All',
    filtered: 'Filtered',
    active: 'Active',
    inactive: 'Inactive',
    filters: 'Filters',
    clearFilters: 'Clear filters'
  },
  [LANGUAGES.FR]: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    edit: 'Modifier',
    delete: 'Supprimer',
    add: 'Ajouter',
    update: 'Mettre à jour',
    create: 'Créer',
    upload: 'Télécharger',
    download: 'Télécharger',
    view: 'Voir',
    restore: 'Restaurer',
    submit: 'Soumettre',
    back: 'Retour',
    next: 'Suivant',
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    confirm: 'Confirmer',
    noDataFound: 'Aucune donnée trouvée',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    status: 'Statut',
    actions: 'Actions',
    details: 'Détails',
    date: 'Date',
    author: 'Auteur',
    version: 'Version',
    currentVersion: 'Version actuelle',
    versionHistory: 'Historique des versions',
    analyze: 'Analyser',
    reviewing: 'En revue',
    published: 'Publié',
    draft: 'Brouillon',
    logout: 'Déconnexion',
    login: 'Connexion',
    register: 'S\'inscrire',
    profile: 'Profil',
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    language: 'Langue',
    english: 'Anglais',
    french: 'Français',
    user: 'Utilisateur',
    manager: 'Gestionnaire',
    admin: 'Administrateur',
    unknown: 'Inconnu',
    none: 'Aucun',
    poweredBy: 'Propulsé par Autobot',
    permissions: 'Permissions des rôles dans l\'Analyseur de compétences',
    confirmBackTitle: 'Confirmer le retour',
    confirmBackMessage: 'Êtes-vous sûr de vouloir revenir en arrière? Toutes les modifications non enregistrées seront perdues.',
    confirmBack: 'Oui, revenir en arrière',
    noChanges: 'Aucun changement détecté',
    saveSuccess: 'Modifications enregistrées avec succès',
    notSpecified: 'Non spécifié',
    dismiss: 'Fermer',
    refresh: 'Actualiser',
    all: 'Tous',
    filtered: 'Filtré',
    active: 'Actif',
    inactive: 'Inactif',
    filters: 'Filtres',
    clearFilters: 'Effacer les filtres'
  }
};
